import styled, { css } from 'styled-components';

import { DEVICE } from '@hero/constants';

const VideoCardOverlay = styled.div`
  align-items: center;
  background-color: var(--color-bg-overlay);
  display: flex;
  inset: 0;
  justify-content: center;
  opacity: 0;
  position: absolute;
  transition: opacity 0.2s;
`;

const VideoCardOverlayIcon = styled.div`
  align-items: center;
  background-color: var(--color-accent-primary-default);
  border-radius: var(--size-border-radius-circle);
  cursor: pointer;
  display: flex;
  height: 56px;
  justify-content: center;
  width: 56px;
`;

const VideoCard = styled.div`
  align-items: center;
  background-color: var(--color-neutral-800);
  display: flex;
  height: 100%;
  justify-content: center;
  position: relative;
  width: 100%;

  ${({ hasRatio }) =>
    !hasRatio &&
    css`
      .video-react {
        height: calc(100vh - 56px - 56px - 48px - 10px);
        max-height: 50vh;

        ${DEVICE.tablet.max} {
          max-height: calc(100vh - 56px - 56px - 48px - 10px);
        }

        padding-top: unset !important;
      }
    `}

  .pause {
    display: none;
  }

  &:hover ${VideoCardOverlay} {
    opacity: 1;
  }

  ${({ isPlaying }) =>
    isPlaying &&
    css`
      .play {
        display: none;
      }
    `}

  ${({ playable }) =>
    !playable &&
    css`
      .video-react-button {
        display: none;
      }
    `}

  .video-react-big-play-button {
    display: none;
  }
`;

export { VideoCard, VideoCardOverlay, VideoCardOverlayIcon };
